export default "https://cdn-static.gokick.com/assets/f4ff00fe02dd4df624a9917ee1bd81ca642b4b73/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";